import { ZoneCapacity } from "../model/ZoneCapacity";

export class ZoneCapacityManager {
    public zoneCapacities: ZoneCapacity[];

    public getCapacityForZone(zoneId: number): any {
        let r: number = -1;
        let l: number = this.zoneCapacities.length;
        for (let i: number = 0; i < l; i++) {
            let zone: ZoneCapacity = this.zoneCapacities[i];
            if (zone.zoneId === zoneId) {
                r = zone.remainingRegistrationCapacity;
                break;
            }
        }
        return r;
    }
}
